module.exports = __webpack_public_path__ + "img/szrm.2ff455ce.png";